import { render } from "./GamesDetails.vue?vue&type=template&id=7dddb4c2&scoped=true&bindings={\"id\":\"props\",\"game\":\"data\"}"
import script from "./GamesDetails.vue?vue&type=script&lang=js"
export * from "./GamesDetails.vue?vue&type=script&lang=js"

import "./GamesDetails.vue?vue&type=style&index=0&id=7dddb4c2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7dddb4c2"

export default script